import SpamStatusesList from "./SpamStatusesList";
export default SpamStatusesList